<template>
    <div class="productcategory">
        <helpInfo :helpData='helpData'></helpInfo>
        <div class="content">
            <div class="table">
                <rcTable ref="rcCouponTable"
                         :tableAttr="tableAttr">
                    <Button slot="tootipL"
                            @click="refresh">
                        <i class="icon-refresh-o-2"></i>
                    </Button>
                    <Button type="primary"
                            @click="create"
                            slot="tootipL">
                        <i class="icon-plus-o-1"></i><span>{{$t('创建')}}</span>
                    </Button>
                </rcTable>
            </div>
        </div>
        <!--创建产品类别-->
        <createproductcategory ref="createbillingstrategy"
                               :operaType="operaType"
                               @refresh="refresh"></createproductcategory>
    </div>

</template>

<script>
import helpInfo from '@c/basic/helpinfo'
import API from '@/service/api'
import rcTable from '@/views/components/basic/rcTable'
import createproductcategory from './components/createproductcategory'

export default {
    name: 'productcategory',
    components: {
        helpInfo,
        rcTable,
        createproductcategory
    },
    data () {
        return {
            loading: false,
            helpData: {
                modelName: this.$t('产品类别')
            },
            operaType: '',
            tableAttr: {
                source: {
                    type: 'get',
                    url: this.urlFormat(API.PRODUCTS_CATEGORIES),
                    params: {}
                },
                searchColumns: [
                    {
                        key: 'categoryNameLike',
                        title: this.$t('名称'),
                        searchDefaultValue: ''
                    }
                ],
                isMultiSelect: false,
                searchShow: true,
                columnsChooseShow: true,
                columns: [
                    {
                        title: this.$t('名称'),
                        width: 300,
                        key: 'categoryName',
                        className: 'tbl-operate',
                        columnShow: true,
                        disabledSearch: true,
                        sortable: true,
                        columnsChoosed: true
                    },
                    {
                        title: this.$t('关联产品'),
                        key: 'products',
                        columnShow: true,
                        disabledSearch: true,
                        sortable: true,
                        columnsChoosed: true,
                        render: (h, params) => {
                            let str = ''
                            if (params.row.products !== null) {
                                for (let i = 0; i < params.row.products.length; i++) {
                                    str += params.row.products[i].productName + ','
                                }
                            }
                            return [
                                h('span', {
                                    attrs: { title: str }
                                }, str.substring(0, str.length - 1))
                            ]
                        }
                    },
                    {
                        title: this.$t('操作'),
                        key: 'operating',
                        width: 150,
                        disabledSearch: true,
                        render: (h, params) => {
                            return h('div', {
                                class: 'tbl-btn-div'
                            }, [
                                h('a', {
                                    on: { click: () => this.editClick(params.row) }
                                }, this.$t('编辑')),
                                h('a', {
                                    class: { 'disabled-per': params.row.categoryType === 'inner' },
                                    on: { click: () => params.row.categoryType !== 'inner' && this.deleteClick(params.row) }

                                }, this.$t('删除'))
                            ])
                        }
                    }
                ]
            }
        }
    },
    methods: {
        // 刷新表单
        refresh () {
            this.$refs.rcCouponTable.refreshTable()
        },
        // 创建
        create () {
            this.operaType = 'add'
            this.$nextTick(() => {
                this.$refs.createbillingstrategy.openModal()
            })
        },
        // 编辑
        editClick (row) {
            this.operaType = 'edit'
            this.$nextTick(() => {
                this.$refs.createbillingstrategy.openModal(row)
            })
        },
        // 删除
        deleteClick (row) {
            this.$Modal.confirm({
                okText: this.$t('确定'),
                cancelText: this.$t('取消'),
                title: this.$t('删除'),
                content: this.$t('确定要删除该条产品类别吗?'),
                onOk: () => {
                    this.axios.delete(this.urlFormat(API.PRODUCTS_CATEGORIES_ID, false, [row.id]))
                        .then(res => {
                            this.refresh()
                        })
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.productcategory {
    background: #fff;
    height: 100%;
    .content {
        overflow-y: auto;
        height: calc(~"100% - 50px");
        position: relative;
        padding: 15px 15px 15px 15px;
    }
}
</style>
<style lang="less">
.productcategory .no-data {
    text-align: center;
    line-height: 100px;
    background: #fff;
    color: #80808;
    margin: 0px 10px 15px 10px;
}
</style>
